import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold py-4 w-250px fs-6",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-5" }
const _hoisted_3 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "menu-link px-5"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Land Factor Options"),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" })
], -1)
const _hoisted_5 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_6 = { class: "menu-item px-3" }
const _hoisted_7 = { class: "menu-item px-3" }
const _hoisted_8 = { class: "menu-item px-3" }
const _hoisted_9 = { class: "menu-item px-3" }
const _hoisted_10 = { class: "menu-item px-3" }
const _hoisted_11 = { class: "menu-item px-3" }
const _hoisted_12 = { class: "menu-item px-3" }
const _hoisted_13 = { class: "menu-item px-3" }
const _hoisted_14 = { class: "menu-item px-3" }
const _hoisted_15 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "menu-link px-5"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Building Factor Options"),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" })
], -1)
const _hoisted_17 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_18 = { class: "menu-item px-3" }
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = { class: "menu-item px-3" }
const _hoisted_21 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "menu-link px-5"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Finishing Quality"),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" })
], -1)
const _hoisted_23 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = { class: "menu-item px-3" }
const _hoisted_26 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "menu-link px-5"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Other Options"),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" })
], -1)
const _hoisted_28 = { class: "menu-sub menu-sub-dropdown w-200px py-4" }
const _hoisted_29 = { class: "menu-item px-3" }
const _hoisted_30 = { class: "menu-item px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/manage/ive/area/areas-listing",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Areas ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/factor-options/street-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Street ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/factor-options/land-size-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Land Size ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/factor-options/direction-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Direction ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/factor-options/plot-specs-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Plot Specs ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/factor-options/location-specs-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Location Specs ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/factor-options/facing-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Facing ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/factor-options/sabah-city-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sabah City ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: "location-options-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Location ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/factor-options/curb-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Curb ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/building-factor-options/building-age-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Building Age ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/building-factor-options/floors-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Number of Floors ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_router_link, {
            to: "/manage/ive/building-factor-options/finishing-quality-listing",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Finishing Quality ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_router_link, {
            to: { name: 'quality-ranges-listing' },
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Quality Ranges ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_router_link, {
            to: { name: 'quality-groups-listing' },
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Quality Groups ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_router_link, {
            to: { name: 'sea-front-listing' },
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sea Front Lengths ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_router_link, {
            to: { name: 'back-street-listing' },
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Back Street Lengths ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}